const API_BASE = process.env.REACT_APP_API_URL || '';

function authHeaders() {
  const token = localStorage.getItem('token');
  const h = { 'Content-Type': 'application/json' };
  if (token) h['Authorization'] = `Bearer ${token}`;
  return h;
}

async function request(method, path, body) {
  const res = await fetch(`${API_BASE}/api${path}`, {
    method,
    headers: authHeaders(),
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
    return null;
  }

  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Error del servidor');
  return data;
}

export const api = {
  /* Auth — fetch directo para que el 401 sea un error visible, no una redirección */
  login: async (username, password) => {
    const res  = await fetch(`${API_BASE}/api/auth/login`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ username, password }),
    });
    const data = await res.json().catch(() => null);
    if (!res.ok) throw new Error(data?.error || 'Error del servidor');
    return data;
  },

  /* Fichas (protegidas) */
  getFichas:   ()       => request('GET',    '/fichas'),
  getFicha:    (id)     => request('GET',    `/fichas/${id}`),
  saveFicha:   (ficha)  => request('POST',   '/fichas', ficha),
  deleteFicha: (id)     => request('DELETE', `/fichas/${id}`),

  /* Ficha pública (sin auth) */
  getPublicFicha: (id) =>
    fetch(`${API_BASE}/api/share/${id}`)
      .then(r => r.ok ? r.json() : Promise.reject(new Error('Ficha no encontrada'))),

  /* Órdenes de compra (protegidas) */
  getOrdenes:   ()      => request('GET',    '/ordenes'),
  getOrden:     (id)    => request('GET',    `/ordenes/${id}`),
  saveOrden:    (orden) => request('POST',   '/ordenes', orden),
  deleteOrden:  (id)    => request('DELETE', `/ordenes/${id}`),
};
